<template>
  <v-card class="card">
    <v-toolbar color="secondary" dark flat>
      <b>Comment Mode</b>
    </v-toolbar>
    <v-card-media :src="src" class="absolute pa-5" width="800" />
  </v-card>
</template>

<script>
import ImageHelper from '@/components/img/ImageHelper';

export default {
  name: 'TaskCommentScreen',
  components: { ImageHelper },
  props: {
    src: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.card {
  position: relative;
}

.absolute {
  position: absolute;
  height: calc(100% - 48px);
  width: 100%;
}

.img {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
